'use client';

import { createContext, useContext } from 'react';

import type { InfluenceAPIClient } from '@kawaak/influence-client';
import { buildInfluenceClient } from '@kawaak/influence-client';

const InfluenceClientContext = createContext<InfluenceAPIClient | undefined>(
  undefined
);

export const useInfluenceClient = () => {
  const client = useContext(InfluenceClientContext);
  if (!client) {
    throw new Error(
      'No InfluenceClient set, use InfluenceClientProvider to set one'
    );
  }
  return client;
};

export const InfluenceClientProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const client = buildInfluenceClient({
    url: process.env.NEXT_PUBLIC_INFLUENCE_API_URL ?? '',
  });

  return (
    <InfluenceClientContext.Provider value={client}>
      {children}
    </InfluenceClientContext.Provider>
  );
};
